$ = require('jquery');
import askAQuestion from './modules/young-drivers/ask-a-question';
import setupFindACarForm from './modules/young-drivers/find-car-form';
import 'nodelist-foreach-polyfill';
import { customEvent, generateLeadEvent } from '../modules/tracking/AnalyticsEvents';

const askAQuestionButtons = document.querySelectorAll('.young-drivers__button--ask-a-question');
askAQuestionButtons.forEach(button => {
    button.addEventListener('click', function() {
        askAQuestion();
    })
});
function checkForQuestionHash() {
    if (window.location.hash == '#ask-a-question') {
        askAQuestion();
    }
}
if ("onhashchange" in window) {
    window.onhashchange = checkForQuestionHash();
}
checkForQuestionHash();

// Events
document.querySelectorAll('.infographic-link').forEach(element => {
    element.addEventListener('click', function() {
        customEvent('Young Drivers', 'Infographic', 'Clicked');
    });
});

const bannerRoadElement = document.querySelector('.banner-road');

if (bannerRoadElement) {
    $(window).on('resize', function() {
        if (window.innerWidth > 768) {
            bannerRoadElement.style.backgroundPositionX = 0;
        }
    });
}

// Mobile banner
if ($('#carousel').length > 0) {
    $('#carousel').slick({
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        speed: 700
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if (window.innerWidth < 768) {
            bannerRoadElement.style.backgroundPositionX = '-' + slick.$slides[nextSlide].querySelector('.item').dataset.x + 'px';
        }
    });

    $('#finance-carousel').slick({
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        speed: 700
    });
}

$(function() {
    // So that the logo classes are applied on page load
    $('.custom-radio input').each(function(k, v) {
        if ($(v).is(':checked')) {
            $(v).parent().find('.img-wrapper').addClass('active');
        }
    });

    $('.custom-radio input').change(function() {
        $(this).closest('.tab-pane').find('.img-wrapper').removeClass('active');

        if ($(this).is(':checked')) {
            $(this).parent().find('.img-wrapper').addClass('active');
        }
    });

    // Don't allow them to change tabs with the nav
    $('.find-car .nav-tabs li a').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
    });

    $('.footer-btn.back').hide();

    $('.footer-btn.back').click(function(e) {
        e.preventDefault();

        $('.find-car .nav-tabs li').filter('.active').prev('li').find('a').tab('show');
    });

    /** Using methods like .collapse('show') ignores the accordion and doesn't close already open collapsible elements.
     * So we need to initialize the collapsible elements with a parent and toggle set to false. */
    $('#findCarAccordion .collapse').collapse({
        toggle: false,
        parent: '#findCarAccordion'
    });

    $(document).on('show.bs.tab', '.find-car a[data-toggle=tab]', function(e) {
        $(e.target).parent().index() == 0 ? $('.footer-btn.back').hide() : $('.footer-btn.back').css('display', 'inline-block');

        let next = $(e.target).parent().next('li').children('a');
        let text = 'Search';
        if (next.length > 0) {
            text = next.text();
        }
        $('.footer-btn.next').text(text);

        $('#step').text($(e.target).parent().index() + 1);
    });

    // $('#selection-model img').hide();
    // $('#selection-model p').hide();
    // $('#selection-details').hide();

    function updateSelectedModel() {
        let el = $('#tab-model input[name="model[]"]:checked');
        let model = el.val();

        if (!model) {
            return;
        }

        customEvent('Young Drivers', 'Model Selected', model);

        // Find the img used for the selected vehicle
        let img = el.parent().find('img');

        $('#selection-model img').prop('src', img.prop('src')).show();
        $('#selection-model #label-name').text(el.data('fullName')).show();
    }

    updateSelectedModel();
    $('#tab-model input[name="model[]"]').change(updateSelectedModel);

    // Since mileage will be blank on page load we cannot know what the value was before - so don't bother doing it on page load
    $('#tab-deposit select[name=mileage]').change(function() {
        $(this).val() ? $('#selection-model #label-mileage').text('Annual mileage: ' + $(this).val()).show() : $('#selection-model #label-mileage').hide();
    });

    function updateSelectedDeposit() {
        $('#tab-deposit input[name=deposit]').val() ? $('#selection-model #label-deposit').text('Deposit: £' + $('#tab-deposit input[name=deposit]').val()).show() : $('#selection-model #label-deposit').hide();
    }

    updateSelectedDeposit();
    $('#tab-deposit input[name=deposit]').change(updateSelectedDeposit);

    function updateSelectedAge() {
        $('#tab-details select[name=age]').val() ? $('#selection-details #label-age').text($('#tab-details select[name=age]').val() + ' years').show() : $('#selection-details #label-age').hide();

        if (!$('#tab-details select[name=age]').val() && !$('#tab-details input[name=postcode]').val()) {
            $('#selection-details').hide();
        } else {
            $('#selection-details').show();
        }
    }

    updateSelectedAge();
    $('#tab-details select[name=age]').change(updateSelectedAge);

    function updateSelectedPostcode() {
        $('#tab-details input[name=postcode]').val() ? $('#selection-details #label-postcode').text($('#tab-details input[name=postcode]').val()).show() : $('#selection-details #label-postcode').hide();

        if (!$('#tab-details input[name=postcode]').val() && !$('#tab-details select[name=age]').val()) {
            $('#selection-details').hide();
        } else {
            $('#selection-details').show();
        }
    }

    updateSelectedPostcode();
    $('#tab-details input[name=postcode]').change(updateSelectedPostcode);

    setupFindACarForm();
});


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/young-drivers.js